<template>
  <v-container>
    <searchPeople keep-alive />
  </v-container>
</template>

<script>
import searchPeople from "@/components/people/search.vue";
export default {
  components: { searchPeople },
  created() {
    document.title = `Search People - ${process.env.VUE_APP_TITLE}`;
  }
};
</script>
